<app-loading>
  <div class="main">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</app-loading>